import { useRouteError } from "react-router";
import { AlertTriangle } from "lucide-react";
import { Button, Icon } from "./ui";

/**
 * Where a page lands if it crashes while drawing (PRD screen 20), in the shop or the admin.
 * Deliberately standalone: if the page frame itself broke, this must not depend on it.
 */
export function CrashScreen({ home, homeLabel }: { home: string; homeLabel: string }) {
  console.error(useRouteError());
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-page p-6">
      <div role="alert" className="max-w-[440px] rounded-lg border border-border-subtle bg-surface-card p-8 text-center shadow-sm">
        <Icon icon={AlertTriangle} size={32} className="mx-auto mb-4 text-warning-700" />
        <h1 className="mb-2 type-h3">Something went wrong on this page</h1>
        <p className="mb-6 type-body text-text-muted">Reloading usually fixes it. If it keeps happening, tell us what you were doing.</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Button onClick={() => window.location.reload()}>Reload the page</Button>
          <Button variant="outline" onClick={() => window.location.assign(home)}>
            {homeLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
